<template>
  <layout404>
    <div>
      <h1 class="mt-5">Ops....</h1>
      <h2 class="mt-5 text-red-300">(404)</h2>
      <small class="mt-10 text-red-300"
        >Parece que não tem nada por aqui!</small
      >
      <router-link to="/" class="mt-10 block"
        >Voltar para a Homepage</router-link
      >
    </div>
  </layout404>
</template>

<script>
import Layout404 from "../layouts/Layout404.vue";

export default {
  name: "PageNotFound",
  components: {
    Layout404
  }
};
</script>
